import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Banner, LinkButton } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetBasketPopupMessagesEnrichedState, makeGetBasketPopupMessagesState, } from '../../../../redux/basket/selectors/BasketSelector';
import { productActions } from '../../../../redux/product/actions/ProductActions';
import { promoBasketPopupActions } from '../../../../redux/promo-basket-popup/actions/PromoBasketPopupActions.creators';
import SessionStorageUtil from '../../../../util/SessionStorageUtil';
import { BUY_GET_POPUP_STORAGE_KEY } from '../../../../constants/StorageKeysConstants';
import { HtmlInclude } from '../../../common/html-include/HtmlInclude';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { getEnrichedMessages } from '../../../../util/BasketOverviewMessagesUtil';
export const BuyAndGetMessages = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const popupMessages = useSelector(makeGetBasketPopupMessagesState());
    const popupMessagesEnriched = useSelector(makeGetBasketPopupMessagesEnrichedState());
    const dispatch = useDispatch();
    const loadProductDataByProductCode = (productCode) => dispatch(productActions.createLoadProductData(productCode));
    const openPromoBasketPopup = (message) => dispatch(promoBasketPopupActions.createPopupOpenAction(message));
    const enrichedMessages = (popupMessagesEnriched.length > 0 ? popupMessagesEnriched : getEnrichedMessages(popupMessages)).filter(message => !!message.message);
    useEffect(() => {
        if (!SessionStorageUtil.getJsonItem(BUY_GET_POPUP_STORAGE_KEY)) {
            const message = enrichedMessages.find(messageItem => !!messageItem.productCode);
            if (message) {
                message.productCode && loadProductDataByProductCode(message.productCode);
                openPromoBasketPopup(message.message);
                SessionStorageUtil.setItem(BUY_GET_POPUP_STORAGE_KEY, true);
            }
        }
    }, [enrichedMessages]);
    return (_jsx(_Fragment, { children: enrichedMessages.map((message, index) => (_jsx(Banner, { status: "informative", text: message.productCode ? (_jsxs(_Fragment, { children: [message.message, ' ', _jsx(LinkButton, { text: t('basket.buyandgetbanner.message.link'), onClick: () => {
                            message.productCode && loadProductDataByProductCode(message.productCode);
                            openPromoBasketPopup(message.message);
                        } })] })) : (_jsx(HtmlInclude, { htmlFragment: message.message })) }, `${message.productCode}-${index}`))) }));
};
